'use client';
import { rem } from '@s7/styles';

const langButtonStyles = (theme)=>({
        padding: theme.fn.space('2s 2.5s'),
        borderRadius: theme.fn.borderRadius('1.5r'),
        width: rem(48),
        height: rem(48)
    });
const langItemStyles = (theme)=>({
        height: rem(56),
        padding: theme.fn.space('2s 4s'),
        width: '100%',
        cursor: 'pointer'
    });
const langWrapperStyles = (theme)=>({
        borderRadius: theme.fn.borderRadius('1.5r'),
        backgroundColor: theme.palette.background.content
    });

export { langButtonStyles, langItemStyles, langWrapperStyles };
//# sourceMappingURL=HeaderLanguage.styles.js.map
